/**
 * This enum represents the possible valid values for sorting in the Open Item Modal.
 */
export enum OpenItemModalSortColumn {
    NAME = 'name',
    MODIFY_DATE_OBJ = 'modifyDateObj',
}
